import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const ForgotPassword = Loadable(lazy(() => import('../pages/auth/ForgotPassword')));
const OtpVerification = Loadable(lazy(() => import('../pages/auth/OtpVerification')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));

const LoginRoutes = {
  path: '/auth',
  children: [
   
    {
      path: 'login',
      element: <LoginPage />
    },
    {
      path: 'register',
      element: <RegisterPage />
    },
    {
      path: 'forgot-password',
      element: <ForgotPassword />
    },
    {
      path: 'otp-verification',
      element: <OtpVerification />
    },
    {
      path: 'reset-password',
      element: <ResetPassword />
    }
  ]
};

export default LoginRoutes;
